import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const NAV_LINKS = [{
  label: 'Problem',
  href: '#problem'
}, {
  label: 'Solution',
  href: '#solution'
}, {
  label: 'Pricing',
  href: '#pricing'
}];
export function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-midnight-deep/80 backdrop-blur-xl border-b border-white/5' : 'bg-transparent'}`} initial={{
    y: -80,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.8,
    ease: [0.22, 1, 0.36, 1]
  }} role="navigation" aria-label="Main navigation" data-id="element-91">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-92">
        <div className="flex items-center justify-between h-16 lg:h-20" data-id="element-93">
          {/* Logo */}
          <a href="#" className="font-sora font-bold text-lg tracking-[0.15em] text-white hover:text-amber transition-colors duration-300" aria-label="Keystonegames home" data-id="element-94">
            KEYSTONEGAMES
          </a>

          {/* Nav Links */}
          <div className="hidden md:flex items-center gap-10" data-id="element-95">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="font-inter text-sm text-text-secondary hover:text-white transition-colors duration-300 tracking-wide" data-id="element-96">
                {link.label}
              </a>)}
          </div>

          {/* CTA */}
          <a href="#pricing" className="hidden sm:inline-flex items-center px-5 py-2.5 bg-amber hover:bg-amber-hover text-midnight-deep font-inter font-semibold text-sm rounded-lg transition-all duration-300 hover:shadow-[0_0_20px_rgba(245,166,35,0.3)]" data-id="element-97">
            Get Started
          </a>
        </div>
      </div>
    </motion.nav>;
}